export default __webpack_public_path__ + "static/ssip-logo-f3f4ddcdc2cf059f41bd8f7939d724cb.png";